module.exports = __webpack_public_path__ + "static/media/Work_Area_ ArrowUp.b2b4b431.svg";